import React from "react";
import { IconButton } from "@metacrm/metacrm-material-ui/dist/Button";
import SyntaxHighlighter from "react-syntax-highlighter";
import { Box } from "@mui/material";
import useCopyToClipboard from "hooks/useCopyToClipboard";

const CodePannel = ({ code, onClick }) => {
  const copyFn = useCopyToClipboard();

  return (
    <Box sx={{ position: "relative" }}>
      <IconButton
        style={{ position: "absolute", right: "10px", top: "10px" }}
        onClick={() => {
          onClick && onClick();
          copyFn(code);
        }}
      >
        <i className="meta-crm-icon-ic_copy font-size-24" />
      </IconButton>
      <SyntaxHighlighter
        language="javascript"
        customStyle={{ borderRadius: "4px" }}
      >
        {code}
      </SyntaxHighlighter>
    </Box>
  );
};
export default CodePannel;
